<template>
  <div id="newsletter_container">
    <div id="newsletter">&nbsp;</div>
    <div id="newsletter_subcontainer" :class="version">
      <img id="newsletter_icon" src="@/assets/imgs/v3-newsletter.png" v-if="version == 'v3'" />
      <img id="newsletter_icon" src="@/assets/imgs/ninja-newspaper.svg" v-else />

      <div id="newsletter_subsubcontainer" :class="version">
        <div v-if="version == 'v3'">
          <h3>BE THE FIRST TO PLAYTEST OUR NEW GAME</h3>
        </div>

        <div v-else>
          <h3>SUBSCRIBE TO OUR NEWSLETTER</h3>
          <p>Stay up to date with the latest news and updates from <b>Dev Null Productions</b>!</p>
        </div>

        <div class="sib-form">
          <div id="sib-form-container" class="sib-form-container">
            <div id="sib-container" style="background: unset">
              <form id="sib-form" method="POST"
                action="https://9cb309cc.sibforms.com/serve/MUIFAPSqlaPghyu2JhRsDar7wKY0_ZN0fTxxtvST9aGFBQyOPz9w9cTeWqGs24U9opzAcI3onDyF8-ylBSDwHGaYaklD6htvbjab-bn7IuutHVydn1fRGpH6vLzVDFuLgNDzKHbtwL0Z4rlKNSOtkFy5P0jHCgyxBTTN7hcXjCBpEZaQfxjRyFJ_Z6fEbrWYAky0ZKIw20MALJmU"
                data-type="subscription">

                <div id="subscribe_container">
                  <div class="sib-input sib-form-block">
                    <div class="form__entry entry_block">
                      <div class="form__label-row ">
                        <label class="entry__label" style="display: none" for="EMAIL" data-required="*"></label>
                        <div class="entry__field">
                          <input class="input" type="text" id="EMAIL" name="EMAIL"
                            placeholder="Enter your email address here"
                            data-required="true" required />
                        </div>
                      </div>

                      <label class="entry__error entry__error--primary" style="font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#661d1d; background-color:#ffeded; border-radius:3px; border-color:#ff4949;"></label>
                      <label class="entry__specification" style="font-size:12px; text-align:left; font-family:Helvetica, sans-serif; color:#8390A4; text-align:left"></label>
                    </div>
                  </div>

                  <button id="subscribe" class="link_button sib-form-block__button sib-form-block__button-with-loader"
                    style="display: flex; font-size:16px; font-weight:700; font-family:Helvetica, sans-serif; color:#FFFFFF; background-color:#3E4857; border-radius:32px; border-width:0px; opacity: 1;"
                    form="sib-form" type="submit">

                    <svg class="icon clickable__icon progress-indicator__icon sib-hide-loader-icon" viewBox="0 0 512 512">
                      <path d="M460.116 373.846l-20.823-12.022c-5.541-3.199-7.54-10.159-4.663-15.874 30.137-59.886 28.343-131.652-5.386-189.946-33.641-58.394-94.896-95.833-161.827-99.676C261.028 55.961 256 50.751 256 44.352V20.309c0-6.904 5.808-12.337 12.703-11.982 83.556 4.306 160.163 50.864 202.11 123.677 42.063 72.696 44.079 162.316 6.031 236.832-3.14 6.148-10.75 8.461-16.728 5.01z" />
                    </svg>

                    Subscribe
                  </button>
                </div>

                <div class="g-recaptcha"
                  data-sitekey="6LeAIWYqAAAAAKQgTmj-EJ9H5Z1xti2mryhh_UCj"
                  data-callback="invisibleCaptchaCallback"
                  data-size="invisible" onclick="executeCaptcha">
                </div>

                <input type="text" name="email_address_check" value="" class="input--hidden">
                <input type="hidden" name="locale" value="en">
              </form>
            </div>

            <div id="error-message" class="sib-form-message-panel" style="font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#661d1d; background-color:#ffeded; border-radius:3px; border-color:#ff4949;max-width:540px;">
              <div class="sib-form-message-panel__text sib-form-message-panel__text--center">
                <svg viewBox="0 0 512 512" class="sib-icon sib-notification__icon">
                  <path d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z" />
                </svg>
                <span class="sib-form-message-panel__inner-text">
                  Your subscription could not be saved. Please try again.
                </span>
              </div>
            </div>
            <div></div>
            <div id="success-message" class="sib-form-message-panel" style="font-size:16px; text-align:left; font-family:Helvetica, sans-serif; color:#085229; background-color:#e7faf0; border-radius:3px; border-color:#13ce66;max-width:540px;">
              <div class="sib-form-message-panel__text sib-form-message-panel__text--center">
                <svg viewBox="0 0 512 512" class="sib-icon sib-notification__icon">
                  <path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 464c-118.664 0-216-96.055-216-216 0-118.663 96.055-216 216-216 118.664 0 216 96.055 216 216 0 118.663-96.055 216-216 216zm141.63-274.961L217.15 376.071c-4.705 4.667-12.303 4.637-16.97-.068l-85.878-86.572c-4.667-4.705-4.637-12.303.068-16.97l8.52-8.451c4.705-4.667 12.303-4.637 16.97.068l68.976 69.533 163.441-162.13c4.705-4.667 12.303-4.637 16.97.068l8.451 8.52c4.668 4.705 4.637 12.303-.068 16.97z" />
                </svg>
                <span class="sib-form-message-panel__inner-text">
                  Your subscription has been successful.
                </span>
              </div>
            </div>
            <div></div>
          </div>
        </div>

        <div id="legal">By clicking Subscribe you agree to receive email communications and accept the data privacy statement.</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LandingSubscribe',

  props : {
    version : String
  },

  mounted : function(){
    window.REQUIRED_CODE_ERROR_MESSAGE = 'Please choose a country code';
    window.LOCALE = 'en';
    window.EMAIL_INVALID_MESSAGE = window.SMS_INVALID_MESSAGE = "Invalid email format, please review and try again.";
    window.REQUIRED_ERROR_MESSAGE = "This field cannot be left blank. ";
    window.GENERIC_INVALID_MESSAGE = "Invalid email format, please review and try again.";
  }
}
</script>

<style scoped lang="scss">
@import '@/scss/custom.scss';

#newsletter_container{
  background-image: linear-gradient($grey-5-alpha62, $black-alpha62);
  border-radius: 32px;
  padding: 10px;
  margin: 150px auto;
}

#newsletter_subcontainer{
  background-image: linear-gradient($black-alpha62, $grey-5-alpha62 100%);
  padding: 33px;
  border-radius: 22px;
  display: flex;
  justify-content: space-around;
  font-family: Alliance No2;
}

#newsletter_subcontainer.v3{
  padding: 20px;
  padding-top: 25px;
  justify-content: space-evenly;
}

#main_layout_v2.md #newsletter_subcontainer,
#main_layout_v2.sm #newsletter_subcontainer,
#main_layout_v2.xs #newsletter_subcontainer{
  flex-wrap: wrap;
}

#newsletter_subsubcontainer.v3{
  margin-top: 15px;
  margin-left: 5px;
}

#newsletter_subcontainer h3{
  font-family: Sunset Gothic Pro Heavy;
}

#main_layout_v2.md #newsletter_subcontainer.v3 h3,
#main_layout_v2.sm #newsletter_subcontainer.v3 h3,
#main_layout_v2.xs #newsletter_subcontainer.v3 h3{
  text-align: center;
  margin-left: unset;
}

#main_layout_v2.md #newsletter_icon,
#main_layout_v2.sm #newsletter_icon,
#main_layout_v2.xs #newsletter_icon{
  margin-bottom: 10px;
}

#newsletter_subcontainer #subscribe_container{
  display: flex;
}

#main_layout_v2.xs #newsletter_subcontainer #subscribe_container{
  flex-direction: column;
}

#sib-container{
  padding: 0;
}

.sib-form{
  padding: 0;
}

.sib-input{
  width: 100%;
}


.sib-form-block{
  padding: 0px
}

#EMAIL{
  width: 100%;
  border-radius: 15px;
  padding: 0 15px;
  color: $black;
}

#main_layout_v2.xs #EMAIL{
  font-size: 10px;
}

#subscribe{
  position: relative;
  left: -40px;
  height: fit-content;
  color: $white;
  padding: 7px 22px;
  justify-content: flex-start;
}

#newsletter_subcontainer.v3 #subscribe{
  left: -20px;
}

#main_layout_v2.xs #subscribe{
  position: unset;
  justify-content: center;
}

.entry__field{
  margin: 0;
  border-top-left-radius: 32px;
  border-bottom-left-radius: 32px;
}

.entry__field:focus-within{
  box-shadow: none;
}

#main_layout_v2.xs .entry__field{
  border-top-right-radius: 32px;
  border-bottom-right-radius: 32px;
}

.entry__error{
  width: 99%;
  margin: 0;
  padding: 3px;
  display: none;
}

#success-message, #error-message{
  margin: 0 16px;
  width: 94%;
}

#legal{
  font-size: 0.7rem;
  margin-top: 5px;
}

#main_layout_v2.md #legal{
  width: 90%;
}

#main_layout_v2.xs #legal{
  width: unset;
}
</style>

<style>
.grecaptcha-badge{
  width: 0 !important;
  height: 0 !important;
}
</style>
